export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14251.37e7042c.jpg";